<app-form-input
[parentForm]="parentForm"

[label]="step2.getspan2"
[type]="'radio'"
[disabled]="disabled"
     [rule]="''"
[value]="radioButtonValue"
[name]="getUid() + '_SepAtt_non'"
[radios]="[
						{
                            value: 'Oui',
							label: step2.getoui
						},
                        {
                            value: 'Non',
							label: step2.getnon
						},
]">
</app-form-input>
<app-oui *ngIf="getIsOui()" [uid]="getUid()" [parentForm]="parentForm" [oui]="grpCommandes.oui" [disabled]="disabled"></app-oui>
